'use strict';

var $cache = {};

var loadMore = function (e) {
    var url = $(e.currentTarget).data('href');

    $.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        success: function (html) {
            var $html = $($.parseHTML(html));
            $('input[name="loadMore"]').remove();
            $('.mk-shop-ratings-paging-body .col-12').append($html);
            var $loadMore = $('input[name="loadMore"]');
            if ($loadMore.length > 0) {
                var loadloreUrl = $('input[name="loadMore"]').val();
                $('button.ratings-load-more').data('href', loadloreUrl);
            } else {
                $('button.ratings-load-more').attr('disabled', 'disabled');
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
};

var bindPagiantionEvents = function () {
    $('.mk-shop-ratings-load-more .ratings-load-more').on('click', loadMore);
};

var loadRatingsContent = function (e) {
    var url = $(e.currentTarget).data('href');
    $.spinner().start();
    $('#nav-ratings').load(url, function () {
        bindPagiantionEvents();
        $.spinner().stop();
    });
};

// Initialize cache - save DOM elements
var initCache = function () {
    $cache.ratings = $('#nav-ratings');
    $cache.ratingsTab = $('#nav-shop-ratings-tab');
};
// Initialize all events
var initEvents = function () {
    $cache.ratingsTab.on('click', loadRatingsContent);
    bindPagiantionEvents();
};

module.exports = function () {
    initCache();
    initEvents();
};
